import { ViewerProps } from 'chat/messages/file/types'
import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'
import { WEB_SCREEN_WIDTH } from 'shared/constants'

export function ImageViewer({ source }: ViewerProps) {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        maxWidth: WEB_SCREEN_WIDTH,
      }}
    >
      <Image
        draggable={false}
        source={{
          uri: source.uri,
        }}
        contentFit="contain"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </View>
  )
}
